// src/components/SEO.js
import React, { useEffect } from 'react';

const SEO = ({ title, description, image, url }) => {
  const siteName = 'bestboard.games';
  const formattedTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = 'Find the best board games suited to your gaming group, preferences, and playing style.';
  
  useEffect(() => {
    // Save the original values to restore later
    const originalTitle = document.title;
    
    // Update document title
    document.title = formattedTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    const originalDescription = metaDescription.content;
    metaDescription.content = description || defaultDescription;
    
    // Update Open Graph tags
    updateMetaTag('property', 'og:title', formattedTitle);
    updateMetaTag('property', 'og:description', description || defaultDescription);
    updateMetaTag('property', 'og:type', 'website');
    if (url) updateMetaTag('property', 'og:url', url);
    if (image) updateMetaTag('property', 'og:image', image);
    updateMetaTag('property', 'og:site_name', siteName);
    
    // Update Twitter tags
    updateMetaTag('name', 'twitter:card', 'summary_large_image');
    updateMetaTag('name', 'twitter:title', formattedTitle);
    updateMetaTag('name', 'twitter:description', description || defaultDescription);
    if (image) updateMetaTag('name', 'twitter:image', image);
    
    // Return cleanup function
    return () => {
      // Only reset the title if we're not going to a new SEO-managed page
      // (this avoids flicker between pages)
      setTimeout(() => {
        if (!document.querySelector('[data-seo="active"]')) {
          document.title = originalTitle;
          metaDescription.content = originalDescription;
        }
      }, 0);
    };
  }, [formattedTitle, description, image, url]);
  
  // Helper function to create or update meta tags
  const updateMetaTag = (attributeName, attributeValue, content) => {
    let tag = document.querySelector(`meta[${attributeName}="${attributeValue}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attributeName, attributeValue);
      document.head.appendChild(tag);
    }
    tag.content = content;
  };
  
  // Add a marker to show that SEO is active on this page
  return <div data-seo="active" style={{ display: 'none' }} />;
};

export default SEO;